import React, { useEffect, useRef } from 'react';
import Webamp from 'webamp';
import { initialTracks as defaultTracks } from './config';

function Winamp({ onClose, onMinimize, initialTracks = defaultTracks }) {
  const ref = useRef(null);
  const webamp = useRef(null);
  useEffect(() => {
    const target = ref.current;
    if (!target) {
      return;
    }

    // Smonta l'istanza di Webamp esistente se presente
    if (webamp.current) {
      webamp.current.dispose();
      webamp.current = null;
    }

    // Crea una nuova istanza di Webamp
    webamp.current = new Webamp({
      initialTracks,
    });

    webamp.current.renderWhenReady(target).then(() => {
      const webampElement = document.querySelector('#webamp');
      if (webampElement && target.contains(webampElement)) {
        target.appendChild(webampElement);
      }
    });

    return () => {
      if (webamp.current) {
        webamp.current.dispose();
        webamp.current = null;
      }
    };
  }, [initialTracks]);

  useEffect(() => {
    if (webamp.current) {
      webamp.current.onClose(onClose);
      webamp.current.onMinimize(onMinimize);
    }
  });

  return (
    <div
      style={{ position: 'fixed', left: 0, top: 0, right: 0, bottom: 0 }}
      ref={ref}
    />
  );
}

export default Winamp;
